module.exports = __webpack_public_path__ + "static/media/join-in-img1-3.1c85b49a.jpg";